var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { ethers } from "ethers";
import { triggerContractByContractName, viewContractByContractName, getContractAddressAndAbiByContractName, } from "../../../utils/ethers/contractHelper";
/**
 * Get points balance from account.
 * @param landId Land Id
 * @param provider Provider
 * @param account Address
 * @param callback Callback
 * @returns any
 */
export const lotteryGetPointsBalance = (landId, provider, account, callback) => __awaiter(void 0, void 0, void 0, function* () {
    const results = yield viewContractByContractName(landId, provider, "userPoints", "pointsBalanceOf", [account], callback);
    return results.length ? results[0].toHexString() : ethers.utils.hexValue(0);
});
/**
 * Json lottery.
 * @param landId Land Id
 * @param signer Signer
 * @param type s for small, l for larget
 * @param callback
 * @returns any
 */
export const lotteryPlayWithTicket = (landId, signer, type, callback) => {
    const methodName = type === "s" ? "playWithSmallTicket" : "playWithLargeTicket";
    return triggerContractByContractName(landId, signer, "lottery", methodName, [], callback, {
        gasLimit: ethers.BigNumber.from(500000),
    });
};
/**
 * Get reward balance in pool.
 * @param landId Land Id
 * @param provider Provider
 * @param callback Callback
 * @returns any
 */
export const lotteryGetTotalRewardInPool = (landId, provider, callback) => __awaiter(void 0, void 0, void 0, function* () {
    const ring = getContractAddressAndAbiByContractName(landId, provider, "ring");
    const results = yield viewContractByContractName(landId, provider, "lottery", "totalRewardInPool", [ring.address], callback);
    return results.length ? results[0].toHexString() : ethers.utils.hexValue(0);
});
